(function () {

    'use strict';

    angular.module('app.home', []);

})();


// WEBPACK FOOTER //
// ./app/home/home.module.js